import { jsx as e, jsxs as c } from "react/jsx-runtime";
import { useState as x } from "react";
import i from "../pill/Pill.js";
import { useTranslation as N } from "react-i18next";
import { COMMENTER_ROOT as T } from "../../utils/popups.js";
import '../../assets/Comments.css';const E = ({ text: r, placeholder: a, btnText: l, title: d, subTitle: u, submitCallback: s, cancelCallback: t }) => {
  const [m, f] = x(r || null), { t: n } = N(), o = () => {
    T.unmount();
  }, p = () => {
    t && t(), o();
  }, h = () => {
    if (s && m)
      return s(m), o();
    t && t(), o();
  };
  return /* @__PURE__ */ e("div", { className: "comment-container", children: /* @__PURE__ */ e("div", { children: /* @__PURE__ */ c("div", { className: "comment-info-container", children: [
    /* @__PURE__ */ c("div", { children: [
      /* @__PURE__ */ e("h5", { className: "comment-title", children: d }),
      /* @__PURE__ */ e("p", { className: "comment-subtitle", children: u })
    ] }),
    /* @__PURE__ */ e(
      "textarea",
      {
        className: "comment-textarea",
        defaultValue: m,
        placeholder: a || n("comment.type-your-comment", "Type your comment..."),
        onChange: (v) => f(v.target.value)
      }
    ),
    /* @__PURE__ */ c("div", { className: "comment-options", children: [
      /* @__PURE__ */ e(i, { text: n("comment.cancel", "Cancel"), clickHandler: p }),
      /* @__PURE__ */ e(i, { text: l || n("comment.save", "Save"), clickHandler: h })
    ] })
  ] }) }) });
};
export {
  E as default
};
